import {Component, Inject, LOCALE_ID} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-reset-student-password-support-article',
    template: `
        <ng-container i18n="@@support.articles.resetStudentPassword">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/students">Students Overview</a>.</span>
                </li>
                <li>
                    <span>Find the student in the list or use the search field to find the student.</span>
                </li>
                <li>
                    <span>
                        Click the three dots on the right side of the student.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/resetStudentPasswordBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Reset password</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <div>
                        <h2>If the student's e-mail address was filled in</h2>
                        <p>The new password will then be sent directly to the student.</p>

                        <h2>If the student's e-mail address was not filled in</h2>
                        <p>The new password will be shown on your screen after confirmation. You must provide this to the student yourself. You may also print the login card and give it to the student.</p>
                    </div>
                </li>
            </ol>
        </ng-container>
    `
})
export class ResetStudentPasswordSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
